import React from 'react';

const ProgressBar = ({
  rightText, centerText, leftText, start, progress, height, filledClass, unfilledClass
}) => {
  const space = 7;
  const timePading = (100 - 7) / 100;

  const calculatedStart = ((start) * timePading);
  const calculatedStop = space + ((progress - start) * timePading);

  const Parentdiv = {
    height,
    margin: 'auto',
    backgroundColor: 'whitesmoke',
    borderRadius: 50,
    position: 'relative',
    marginLeft: '10px'
  };

  const Childdiv = {
    height,
    width: `${progress ? (calculatedStop) : 0}%`,
    marginLeft: `${calculatedStart}%`,
    marginTop: '-2px',
    borderRadius: 50,
    position: 'absolute',
    top: '0'
  };

  const rightTextCSS = {
    height,
    paddingRight: 10,
    float: 'right',
    display: 'flex',
    alignItems: 'center',
    marginTop: 'calc(-2px + 0.5vw)'
  };


  const leftTextCSS = {
    height,
    paddingLeft: 10,
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    marginTop: 'calc(-2px + 0.5vw)'
  };

  const centerTextCSS = {
    height,
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%,-5%)',
    display: 'flex',
    alignItems: 'center',
    marginTop: 'calc(-2px + 0.5vw)'
  };

  return (
    <>
      <div className={`${unfilledClass}`} style={Parentdiv}>
        {leftText && <span style={leftTextCSS}>{leftText}</span>}
        {centerText && <span className="bar-infront-text" style={centerTextCSS}>{centerText}</span>}
        <span style={rightTextCSS}>{rightText}</span>
        {start !== progress && <div className={`bar-infront ${filledClass}`} style={Childdiv} />}
      </div>
    </>
  );
};

export default ProgressBar;
